import { internalDashboardTabsArray } from "./constants";
import styles from "./styles.module.scss";

export function InternalDashoardTabs({ selectedTab, setSelectTab }: any) {
  return (
    <div className={styles.tabsContainer}>
      {internalDashboardTabsArray.map((state: any) => {
        return (
          <button
            key={state.key}
            type="button"
            className={`${styles.tab} ${
              selectedTab === state.key ? styles.activeTab : ""
            }`}
            onClick={() => {
              setSelectTab(state?.key);
            }}
          >
            {state.label}
          </button>
        );
      })}
    </div>
  );
}
